import { FC } from 'react';
import { Chart, KaizenChartForHooks } from '@kaizenplatform/kaizen-chartjs';
import GlobalPeriod from '../../../../entity/GlobalPeriod';
import { IChart as LiftReportChart } from '../../../../entity/Chart';
import Loading from '../Loading';
import styled from '@emotion/styled';
import useKaizenChart from '../../../../hooks/useKaizenChart';
import { PaperContent, PaperItem, PaperText, PaperTitle, PaperTitleText, StyledPaper } from '../../primitive/Paper';

type Props = {
  liftReport?: LiftReportChart;
  goalId: string | null;
  liftReportChartSetting: GlobalPeriod;
  liftReportLoading: boolean;
};

const LiftUpReport: FC<Props> = ({ liftReport, goalId, liftReportChartSetting, liftReportLoading }) => {
  const { chartData, frequencyData, initialFrequency, frequencyLoading, chartLoading, refetch } = useKaizenChart(
    liftReportChartSetting,
    goalId,
    liftReport,
  );

  return (
    <StyledPaper>
      <PaperTitle>
        <PaperTitleText>コンバージョンリフト推移</PaperTitleText>
      </PaperTitle>
      <PaperContent>
        <PaperItem>
          <PaperText>
            Kaizen活動期間中のコンバージョンリフトの推移と、目標コンバージョンリフト数に対してどれぐらいギャップがあるかを確認することができます。
          </PaperText>
        </PaperItem>
        <PaperItem>
          {liftReportLoading ? (
            <LoadingContainer>
              <Loading />
            </LoadingContainer>
          ) : (
            <KaizenChartForHooks
              chartData={chartData ? ((chartData as any).chart as Chart) : undefined}
              identifier={{ id: liftReport ? liftReport.id : '' }}
              scope={{
                from: liftReportChartSetting.from.toISO(),
                to: liftReportChartSetting.to.toISO(),
                frequency: initialFrequency,
              }}
              loading={liftReportLoading || frequencyLoading || chartLoading}
              refetch={refetch}
              frequencies={(frequencyData as any) ? ((frequencyData as any).chart as Chart).frequencies : undefined}
            />
          )}
        </PaperItem>
      </PaperContent>
    </StyledPaper>
  );
};

const LoadingContainer = styled('div')({
  margin: '0px 24px',
  height: '600px',
});

export default LiftUpReport;
